/* eslint-disable arrow-body-style */

import http from '@gp/utils/httpTS';

import type { IBaseResponse } from '@home/types/common';
import type {
  EditProjectUpdateType,
  DeleteProjectUpdateType,
  ProjectUpdatesFetcherParams,
  queryActionItemsListParamsType,
  IGRActionItemDTO,
} from '@gp/types/projectUpdate.d';

export const updateRenewableFrequency = (params: any): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/updates/edit_update_every',
    method: 'POST',
    data: params,
    original: true,
  });
};

export const queryProjectUpdateList = (params: ProjectUpdatesFetcherParams): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/updates/list',
    method: 'get',
    params,
    original: true,
  });
};

export const projectUpdateListDownload = (params: {
  project_id: string;
  milestone_id: string;
  current_milestone_id: string;
  file_type: 1 | 2; // 1: csv 2: excal
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/updates/list_download',
    method: 'get',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

export const editProjectUpdate = (params: EditProjectUpdateType): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/updates/edit',
    method: 'POST',
    data: params,
    original: true,
  });
};

export const deleteProjectUpdate = (params: DeleteProjectUpdateType): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/updates/delete',
    method: 'POST',
    data: params,
    original: true,
  });
};

export const queryActionItemsList = (params: queryActionItemsListParamsType): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/updates/action_list',
    method: 'POST',
    data: params,
    original: true,
  });
};

export const actionItemsListDownLoad = (params: {
  project_id: string;
  milestone: string[]; // id数组
  start_date: string; // YYYY-MM-DD
  end_date: string; // YYYY-MM-DD
  order: 'desc' | 'asc';
  file_type: 1 | 2; // 1: csv 2: excal
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/updates/action_list_downloadV2',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

export const fetchGRActionItems = async (params: {
  project_id: string;
  // 粒度 1:monthly 2:weekly
  granularity: '1' | '2' | (string & {});
  // 开始时间
  start_date: string;
  // 结束时间
  end_date: string;
}): IBaseResponse<{ workplans: IGRActionItemDTO[] | null; milestone_id: string; milestone: string }> => {
  return http({
    url: '/api/v1/globalpedia_pc/updates/inherit_gr_action',
    method: 'POST',
    data: params,
    rawData: true,
  }) as any;
};
